module.exports = __webpack_public_path__ + "files/4856ae22ccb120426736f54ca9f32d57.png";